import React from 'react';

const MapComponent = () => {
  return (
    <div className="relative w-full h-[600px] rounded">
      <iframe
        title="Embedded Map"
        width="100%"
        height="100%"
        frameBorder="0"
        scrolling="no"
        marginHeight="0"
        marginWidth="0"
        src="https://www.openstreetmap.org/export/embed.html?bbox=31.06052%2C30.01156%2C31.08052%2C30.03156&layer=mapnik&marker=30.02156%2C31.07052"
        style={{ border: 0 }}
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default MapComponent;
